<template>

     <span>
        <p-search-screen
            title="Reports"
            :filters="filters"
            :fields="fields"
            :filterBy="filterBy"
            :show-bottom-paging="false"
            :show-top-paging="false"
            api-destination="reports"
        >
            <template v-slot:cell(view)="{ item }">
                <p-button variant="outline-primary"
                        @click.stop="launchReport(item)"
                        size="sm"
                        :is-busy="isBusy">View</p-button>
            </template>
        </p-search-screen>

        <TotalInventoryReport ref="Total Inventory Value"></TotalInventoryReport>
        <InventoryByDcc ref="Inventory By DCC"></InventoryByDcc>
        <InventoryByFixture ref="Inventory By Fixture"></InventoryByFixture>
        <InventoryNotCounted ref="Inventory Not Counted"></InventoryNotCounted>
        <PriceListReport ref="Price List"></PriceListReport>
        <CourseListReport ref="Course List"></CourseListReport>
        <AuthorListReport ref="Author List" />
        <TextbookListReport ref="Textbook List" />
        <SalesByDccReport ref="Sales By DCC"/>
        <PosDeviceReconciliationReport ref="POS Device Reconciliation"/>
        <CashierReconciliationReport ref="POS Device by Cashier(s) Reconciliation"/>
        <TaxesByJurisdictionReport ref="Sales/Use Tax"/>
        <RentalReconciliationReport ref="Rental Reconciliation"/>
        <RentalStatusReport ref="Rental Status"/>
        <AppleSalesReport ref="Apple Report"/>
        <InvoiceDetailReport ref="Invoice Detail Report"/>
        <WebSalesReport ref="Web Sales and Tax by State"/>
        <ProductSalesReport ref="Product Sales"/>
        <ProductSalesMarginReport ref="Product Sales &amp; Margin"/>
        <SalesByHourReport ref="Sales By Hour"/>
        <NonMerchSalesReport ref="Non-Merch Sales"/>
        <DailySalesReport ref="Daily Sales Report"/>
    </span>
</template>

<script>
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';

import TotalInventoryReport from '@/views/Reports/PhysicalInventory/TotalInventory.vue';
import InventoryByDcc from '@/views/Reports/PhysicalInventory/InventoryByDcc.vue';
import InventoryByFixture from '@/views/Reports/PhysicalInventory/InventoryByFixture.vue';
import InventoryNotCounted from '@/views/Reports/PhysicalInventory/InventoryNotCounted.vue';
import AuthorListReport from '@/views/Reports/Terms/AuthorList.vue';
import CourseListReport from '@/views/Reports/Terms/CourseList.vue';
import PriceListReport from '@/views/Reports/Terms/PriceList.vue';
import TextbookListReport from '@/views/Reports/Terms/TextbookList.vue';
import SalesByDccReport from '@/views/Reports/Sales/SalesByDcc.vue';
import PosDeviceReconciliationReport from '@/views/Reports/Sales/PosDeviceReconciliation.vue';
import CashierReconciliationReport from '@/views/Reports/Sales/CashierReconciliation.vue';
import TaxesByJurisdictionReport from '@/views/Reports/Sales/TaxesByJurisdiction.vue';
import RentalReconciliationReport from '@/views/Reports/Sales/RentalReconciliation.vue';
import RentalStatusReport from '@/views/Reports/Rentals/RentalStatus.vue';
import AppleSalesReport from '@/views/Reports/Sales/AppleSales.vue';
import InvoiceDetailReport from '@/views/Reports/Sales/InvoiceDetailReport.vue';
import WebSalesReport from '@/views/Reports/Sales/WebSales.vue';
import ProductSalesReport from '@/views/Reports/Sales/ProductSales.vue';
import ProductSalesMarginReport from '@/views/Reports/Sales/ProductSalesMargin.vue';
import SalesByHourReport from '@/views/Reports/Sales/SalesByHour.vue';
import NonMerchSalesReport from '@/views/Reports/Sales/NonMerchSales.vue';
import DailySalesReport from '@/views/Reports/Sales/DailySalesReport.vue';
import { downloadFileToBrowser } from '@/components/Common/BrowserDownload.js';
import axios from 'axios';

export default {
    mixins: [SearchStorage],
    data() {
        return {
            isBusy: false,
            filterName: 'reportsFilter',
            filters: {
                automatic: "",
                perPage: 100,
                sortBy: 'name',
                sortDesc: true,
                searchBy: 'All'
            },
            filterBy: ['All', 'Name','Category', 'Description'],
            fields: [
                {
                    key: 'view',
                    class: 'tcw100'
                },
                {
                    key: 'name',
                    sortable: true
                },
                {
                    key: 'category',
                    sortable: true
                },
                {
                    key: 'description',
                    sortable: true
                }
            ]
        };
    },
    methods: {
        async launchReport(item){
        if (this.isBusy) return;
        if(item.name == 'Gift Card Summary')
        {
            let apiUrl = '/giftcards/exportgiftcards';
            this.isBusy = true;
            axios
                 .get(apiUrl, {
                    responseType: 'blob'
                })
                .then(result => {
                    downloadFileToBrowser(
                        result.data,
                        `Gift Card Report`,
                         'application/pdf'
                    );
                    this.$appSuccess(
                            `Gift Card Report generated successfully.`
                        )
                })
                .finally(() => {
                    this.isBusy = false;
                });
            }
            else if(item.name == 'Stock Adjustment')
            {
                this.$router.push('/stockadjustmentreport');
            }
            else
            {
                this.isBusy = false;
                this.$refs[item.name].show();
            }
        }
    },
    components: {
        TotalInventoryReport,
        InventoryByDcc,
        InventoryByFixture,
        InventoryNotCounted,
        AuthorListReport,
        CourseListReport,
        PriceListReport,
        TextbookListReport,
        SalesByDccReport,
        PosDeviceReconciliationReport,
        CashierReconciliationReport,
        TaxesByJurisdictionReport,
        RentalReconciliationReport,
        RentalStatusReport,
        AppleSalesReport,
        InvoiceDetailReport,
        WebSalesReport,
        ProductSalesReport,
        ProductSalesMarginReport,
        SalesByHourReport,
        NonMerchSalesReport,
        DailySalesReport
    }
};
</script>
<style scoped></style>
